import { render, staticRenderFns } from "./generalSuicideAlertMultipleQuestions.vue?vue&type=template&id=a6ac393e"
import script from "./generalSuicideAlertMultipleQuestions.vue?vue&type=script&lang=js"
export * from "./generalSuicideAlertMultipleQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports